/**
 * @flow
 */

import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import Config from 'config';
import { Provider } from 'react-redux';
import configureStore from './store/configure-store';
import App from './app';
import { getSessionId } from './lib/session-id';
import { loadLocaleData } from './lib/locale-loader';
import { fromJS } from 'immutable';
import { LOCAL_STORAGE_LOCALE } from './modules/locale/actions';
import { DEFAULT_LOCALE } from './lib/locale-loader';

import './styles/index.css';

import IntlSwapper from './components/intl-swapper';
import GoogleTagManager from './components/google-tag-manager';
import WithApollo from './components/with-apollo';

//-----------------------------------------------------------------------------
// Error Handling
//-----------------------------------------------------------------------------

if (Config.sentryDSN && (typeof Raven === 'object')) {
  Raven.config(Config.sentryDSN, { release: __VERSION__ }).install();
  Raven.setExtraContext({ uuid: getSessionId() });
}

//-----------------------------------------------------------------------------
// Amplitude Init
//-----------------------------------------------------------------------------
if (Config.amplitude.id) {
  /* eslint-disable */
  // $FlowIssue
  (function(e,t){var n=e.amplitude||{_q:[],_iq:{}};var r=t.createElement("script");r.type="text/javascript";r.async=true;r.src="https://cdn.amplitude.com/libs/amplitude-4.2.1-min.gz.js";r.onload=function(){if(e.amplitude.runQueuedFunctions){e.amplitude.runQueuedFunctions()}else{console.log("[Amplitude] Error: could not load SDK")}};var i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i);function s(e,t){e.prototype[t]=function(){this._q.push([t].concat(Array.prototype.slice.call(arguments,0)));return this}}var o=function(){this._q=[];return this};var a=["add","append","clearAll","prepend","set","setOnce","unset"];for(var u=0;u<a.length;u++){s(o,a[u])}n.Identify=o;var c=function(){this._q=[];return this};var l=["setProductId","setQuantity","setPrice","setRevenueType","setEventProperties"];for(var p=0;p<l.length;p++){s(c,l[p])}n.Revenue=c;var d=["init","logEvent","logRevenue","setUserId","setUserProperties","setOptOut","setVersionName","setDomain","setDeviceId","setGlobalUserProperties","identify","clearUserProperties","setGroup","logRevenueV2","regenerateDeviceId","logEventWithTimestamp","logEventWithGroups","setSessionId","resetSessionId"];function v(e){function t(t){e[t]=function(){e._q.push([t].concat(Array.prototype.slice.call(arguments,0)))}}for(var n=0;n<d.length;n++){t(d[n])}}v(n);n.getInstance=function(e){e=(!e||e.length===0?"$default_instance":e).toLowerCase();if(!n._iq.hasOwnProperty(e)){n._iq[e]={_q:[]};v(n._iq[e])}return n._iq[e]};e.amplitude=n})(window,document);
  /* eslint-enable */

  window.amplitude.getInstance().init(Config.amplitude.id);
}

//-----------------------------------------------------------------------------
// Google Tag
//-----------------------------------------------------------------------------

if (Config.googleTagManager.show) {
  ReactDOM.render(<GoogleTagManager gtmId={Config.googleTagManager.gtmId} />, (document: any).getElementById('noscript'));
}

//-----------------------------------------------------------------------------
// Optimizely
//-----------------------------------------------------------------------------

                                /*  TODO   */

//-----------------------------------------------------------------------------
// i18n
//-----------------------------------------------------------------------------

const localeParam = window.location.href.match(/(l\=)([a-zA-z]{2})(\-[a-zA-Z]{2})?/) || [];
const localeParamString = (localeParam[2] || '') + (localeParam[3] || '');
if (localeParamString && !localStorage.getItem(LOCAL_STORAGE_LOCALE)) {
  localStorage.setItem(LOCAL_STORAGE_LOCALE, localeParamString);
}
const userLocales =  navigator.languages || (navigator.language && [navigator.language]) || [DEFAULT_LOCALE];

loadLocaleData(userLocales).then(([locale, messages]) => {
  const initialState = { locale: fromJS({ locale, messages }) };
  const store = configureStore(initialState);
  ReactDOM.render(
    <Provider store={store}>
      <WithApollo>
        <IntlSwapper store={store}>
          <App />
        </IntlSwapper>
      </WithApollo>
    </Provider>,
    document.getElementById('root')
  );
});



// WEBPACK FOOTER //
// ./src/index.js